import { inputAnatomy } from "@chakra-ui/anatomy"
import { createMultiStyleConfigHelpers } from "@chakra-ui/react"
import { textV4Variants } from "../../components/TextV4/TextV4"

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(inputAnatomy.keys)

const v4 = definePartsStyle({
  field: {
    ...textV4Variants.v4_dekstop_d_headline,
    paddingY: "12px",
    paddingX: "16px",
    borderRadius: "8px",
    borderWidth: "1px",
    borderColor: "jarivis-neutral.50",
    color: "jarivis-neutral.50",

    transition: "all 0.2s ease",

    _focus: {
      borderColor: "Jarivis-Blue-Border",
    },

    /* Input Invalid */
    _invalid: {
      borderColor: "Jarivis-Danger-Border",
      color: "Jarivis-Danger-Border",
    },

    /* Form control invalid */
    _groupInvalid: {
      borderColor: "Jarivis-Danger-Border",
      color: "Jarivis-Danger-Border",
    },

    _disabled: {
      opacity: 0.75,
    },
  },
})

const jUnderline = definePartsStyle({
  field: {
    backgroundColor: "transparent",
    borderWidth: "0px 0px 1px 0px",
    borderRadius: "0px",
    paddingX: "0px",
    borderBottomColor: "netral.50",
    paddingY: "10px",
  },
})

const inputTheme = defineMultiStyleConfig({
  variants: {
    "j-underline": jUnderline,
    v4,
  },
})

export default inputTheme